export const capitalizeFirstLetter = (word:string, locale = navigator.language) =>
    !word ? '' : word[0].toLocaleUpperCase(locale) + word.substr(1);